module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "ident"
  }, [_c('p', {
    staticClass: "nomcol"
  }, [_c('i', [_vm._v("A")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCIENT")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN")]), _c('br'), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('i', [_vm._v("ON")])]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CRIPTURE")])]), _c('div', {
    staticClass: "fig",
    attrs: {
      "id": "part1_fig0"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "image",
      "src": "images/filet_ptit.jpg",
      "width": "500"
    }
  })])]), _c('p', {
    staticClass: "trad"
  }, [_c('span', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LD")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTAMENT")]), _c('br'), _vm._v("IV")])]), _c('div', {
    staticClass: "pagetitre"
  }, [_c('a', {
    attrs: {
      "id": "pagetitre"
    }
  }, [_c('p', {
    staticClass: "ident_tit"
  }, [_c('span', [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA")]), _vm._v(", J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDGES")]), _vm._v(", R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTH")]), _vm._v(","), _c('br'), _vm._v("1-2 S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMUEL")])])]), _c('p', {
    staticClass: "trad"
  }, [_c('span', [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITED BY")])])]), _c('div', {
    staticClass: "auteur_ident"
  }, [_c('span', [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" R. F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RANKE")])])]), _c('div', {
    staticClass: "fig",
    attrs: {
      "id": "part1_fig1"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "image",
      "src": "images/filet_ptit.jpg",
      "width": "500"
    }
  })])]), _c('p', {
    staticClass: "trad"
  }, [_c('span', [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENERAL")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITOR")]), _c('br'), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOMAS")]), _vm._v(" C. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DEN")])])])]), _c('div', {
    staticClass: "edit"
  }, [_c('a', {
    attrs: {
      "id": "pagetitre"
    }
  }), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.ivpress.com/academic",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "image",
      "id": "logo",
      "src": "images/IVP_Academic_C.jpg",
      "width": "110"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fe5f733","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ident1.vue
// module id = 57
// module chunks = 0